import {Injectable} from "@angular/core";
import {GridLayoutService} from "@irb-common/interfaces/grid-layout.service";
import {DeleteCellComponent} from "@irb-common/components/grid/renderers/delete.cell.component";
import {DeleteHeaderComponent} from "@irb-common/components/grid/renderers/delete.header.component";
import {UtilityService} from "@irb-common/services/utility.service";
import {TruncateTooltipCellComponent} from "@irb-common/components/grid/renderers/truncatetooltip.cell.component";
import {CustomfilterComponent} from "@irb/irb-clients/portfolios/customfilter/customfilter.component";
import {IrbAgSetColumnFilterComponent} from "@irb-common/components/irebal-ag-grid-ent-avatar/irb-ag-set-column-filter/irb-ag-set-filter.component";
import {RequiredTextboxEditor} from "@irb-common/components/grid/editors/required-textbox-editor";
import {MmcAssetClassSettingsComponent} from "@irb/irb-settings/settings-mmc/mmc-asset-class-settings/mmc-asset-class-settings.component";


@Injectable({
    providedIn: "root"
})
export class MmcSettingsAssetClassGridLayoutService implements GridLayoutService<MmcAssetClassSettingsComponent> {
    sizeFor: any;

    getFrameworkComponents(): any {
        return {
            "DeleteHeaderComponent": DeleteHeaderComponent,
            "DeleteCellComponent": DeleteCellComponent,
            "TruncateTooltipCellComponent": TruncateTooltipCellComponent,
            "customFilterToolPanel": CustomfilterComponent,
            "irbAgSetColumnFilterComponent": IrbAgSetColumnFilterComponent,
            "RequiredTextboxEditor": RequiredTextboxEditor
        };
    }

    constructor(private util: UtilityService) {
        this.sizeFor = {
            "symbol": 60
        };
    }

    getColumnDefs(parent: any) {
        return [{
            headerName: "",
            cellRenderer: "DeleteCellComponent",
            cellRendererParams: {
                message: "Delete this asset class?",
                proceed: parent.delete.bind(parent),
                cancel: parent.cancelDelete.bind(parent)
            },
            resizable: false,
            minWidth: 25,
            maxWidth: 25,
            width: 25,
            pinned: "left",
            suppressColumnsToolPanel: true,
            lockPosition: true,
            colId: 'deleteAssetClass'
        },
            {
                headerName: "Asset Class",
                field: "label",
                pinned: "left",
                lockVisible: true,
                lockPosition: true,
                editable: true,
                cellEditor: 'RequiredTextboxEditor',
                cellRenderer: 'cellRendererFormatter',
                cellRendererParams: 'TruncateTooltipCellComponent',
                tooltipPosition: 'bottom',
                cellEditorParams: {
                    required: true,
                    autofocus: true,
                    width: '100%',
                    tooltiptext: 'Please enter an asset class'
                },
                sortable: true,
                sort:'asc',
                colId: 'label'
            },
        ];
    }

}
